import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from 'intl/messages';
import NavDropdown from './NavDropdown';

const NavLangs: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <NavDropdown label={formatMessage({ ...messages.languages })}>
      <a className='text-sm px-2' href='/bg/'>
        <FormattedMessage {...messages.bulgarian} />
        &nbsp; (български)
      </a>
      <a className='text-sm px-2' href='/cs/'>
        <FormattedMessage {...messages.czech} />
        &nbsp; (čeština)
      </a>
      <a className='text-sm px-2' href='/da/'>
        <FormattedMessage {...messages.danish} />
        &nbsp; (dansk)
      </a>
      <a className='text-sm px-2' href='/de/'>
        <FormattedMessage {...messages.german} />
        &nbsp; (Deutsche)
      </a>
      <a className='text-sm px-2' href='/el/'>
        <FormattedMessage {...messages.greek} />
        &nbsp; (Ελληνικά)
      </a>
      <a className='text-sm px-2' href='/en/'>
        <FormattedMessage {...messages.english} />
        &nbsp; (English)
      </a>
      <a className='text-sm px-2' href='/es/'>
        <FormattedMessage {...messages.spanish} />
        &nbsp; (Español)
      </a>
      <a className='text-sm px-2' href='/et/'>
        <FormattedMessage {...messages.estonian} />
        &nbsp; (Eesti keel)
      </a>
      <a className='text-sm px-2' href='/fi/'>
        <FormattedMessage {...messages.finnish} />
        &nbsp; (Suorittaa loppuun)
      </a>
      <a className='text-sm px-2' href='/fr/'>
        <FormattedMessage {...messages.french} />
        &nbsp; (français)
      </a>
      <a className='text-sm px-2' href='/he/'>
        <FormattedMessage {...messages.hebrew} />
        &nbsp; (עִברִית)
      </a>
      <a className='text-sm px-2' href='/hr/'>
        <FormattedMessage {...messages.croatian} />
        &nbsp; (hrvatski)
      </a>
      <a className='text-sm px-2' href='/hu/'>
        <FormattedMessage {...messages.hungarian} />
        &nbsp; (Magyar)
      </a>
      <a className='text-sm px-2' href='/it/'>
        <FormattedMessage {...messages.italian} />
        &nbsp; (italiano)
      </a>
      <a className='text-sm px-2' href='/ja/'>
        <FormattedMessage {...messages.japanese} />
        &nbsp; (日本語)
      </a>
      <a className='text-sm px-2' href='/ko/'>
        <FormattedMessage {...messages.korean} />
        &nbsp; (한국인)
      </a>
      <a className='text-sm px-2' href='/nb/'>
        <FormattedMessage {...messages.norwegian} />
        &nbsp; (norsk)
      </a>
      <a className='text-sm px-2' href='/nl/'>
        <FormattedMessage {...messages.dutch} />
        &nbsp; (Nederlands)
      </a>
      <a className='text-sm px-2' href='/pl/'>
        <FormattedMessage {...messages.polish} />
        &nbsp; (Polskie)
      </a>
      <a className='text-sm px-2' href='/pt/'>
        <FormattedMessage {...messages.portuguese} />
        &nbsp; (Português)
      </a>
      <a className='text-sm px-2' href='/ro/'>
        <FormattedMessage {...messages.romanian} />
        &nbsp; (Română)
      </a>
      <a className='text-sm px-2' href='/ru/'>
        <FormattedMessage {...messages.russian} />
        &nbsp; (русский)
      </a>
      <a className='text-sm px-2' href='/sk/'>
        <FormattedMessage {...messages.slovak} />
        &nbsp; (slovenský)
      </a>
      <a className='text-sm px-2' href='/sl/'>
        <FormattedMessage {...messages.slovenian} />
        &nbsp; (Slovenščina)
      </a>
      <a className='text-sm px-2' href='/sr/'>
        <FormattedMessage {...messages.serbian} />
        &nbsp; (Slovenščina)
      </a>
      <a className='text-sm px-2' href='/sv/'>
        <FormattedMessage {...messages.swedish} />
        &nbsp; (svenska)
      </a>
      <a className='text-sm px-2' href='/tr/'>
        <FormattedMessage {...messages.turkish} />
        &nbsp; (Türk)
      </a>
      <a className='text-sm px-2' href='/vi/'>
        <FormattedMessage {...messages.vietnamese} />
        &nbsp; (Tiếng Việt)
      </a>
      <a className='text-sm px-2' href='/zh/'>
        <FormattedMessage {...messages.chinese} />
        &nbsp; (中文)
      </a>
    </NavDropdown>
  );
};

export default NavLangs;
